module.exports = __webpack_public_path__ + "res/ic_menu_add.58d45547e003337add7b8fa5a65e567a.png";